module.exports = __webpack_public_path__ + "assets/9c498fa168f90dd0586e16b41fb9dd5c-DSC_0782.jpg";